'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SeparadorMilesDirective = function () {
    function SeparadorMilesDirective() {
        _classCallCheck(this, SeparadorMilesDirective);

        this.restrict = 'A';
        this.require = 'ngModel';
    }

    _createClass(SeparadorMilesDirective, [{
        key: '_limpiarEntrada',
        value: function _limpiarEntrada(input) {

            var esNegativo = input.indexOf("-") == 0;

            input = input.replace(/[\.\D]/g, '');
            if (input !== "") {
                input = Number(input);
                input = isNaN(input) ? "" : input.toString();
            }

            return esNegativo ? "-" + input : input;
        }
    }, {
        key: '_formatear',
        value: function _formatear(input) {
            return input.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }, {
        key: '_doGetCaretPosition',
        value: function _doGetCaretPosition(oField) {

            var iCaretPos = 0;

            if (document.selection) {
                oField.focus();
                var oSel = document.selection.createRange();
                oSel.moveStart('character', -oField.value.length);
                iCaretPos = oSel.text.length;
            } else if (oField.selectionStart || oField.selectionStart == '0') {
                iCaretPos = oField.selectionStart;
            }

            return iCaretPos;
        }
    }, {
        key: '_doSetCaretPosition',
        value: function _doSetCaretPosition(oField, pos, oldLength, newLength) {
            if (oldLength < newLength) {
                pos += newLength - oldLength;
            } else if (oldLength > newLength) {
                pos -= oldLength - newLength;
            }
            if (document.selection) {
                oField.focus();
                var oSel = document.selection.createRange();
                oSel.moveStart('character', -pos);
            } else {
                oField.selectionStart = pos;
                oField.selectionEnd = pos;
            }
        }
    }, {
        key: 'link',
        value: function link(scope, elem, attr, ngModelCtrl) {
            var _this = this;

            ngModelCtrl.$parsers.push(function (value) {
                if (value == null || value === "") return null;

                var input = value.toString();
                var oldLength = input.length;
                var newLength = oldLength;

                input = _this._limpiarEntrada(input);

                var pos = _this._doGetCaretPosition(elem[0]);

                if (input === "") {
                    ngModelCtrl.$setViewValue("");
                    ngModelCtrl.$render();
                    return null;
                }

                var formatedInput = _this._formatear(input);
                newLength = formatedInput.length;

                ngModelCtrl.$setViewValue(formatedInput);
                ngModelCtrl.$render();

                _this._doSetCaretPosition(elem[0], pos, oldLength, newLength);

                var num = Number(input);

                return isNaN(num) ? null : num;
            });

            ngModelCtrl.$formatters.push(function (value) {
                if (value == null || value === "") return null;
                if (!isNaN(value)) return _this._formatear(value.toString());
                return null;
            });
        }
    }]);

    return SeparadorMilesDirective;
}();

exports.default = SeparadorMilesDirective;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/separador-miles.directive.js